import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, Renderer2 } from '@angular/core'
import { Router } from '@angular/router'
import { forkJoin } from 'rxjs'

import { ILicense } from '../../../Interface/license'
import { ITrack } from '../../../Interface/track'
import { CartService } from '../../../services/cart.service'
import { CoreEnvironmentService } from '../../../services/core-environment.service'
import { LicenseService } from '../../../services/license.service'
import { NotificationService } from '../../../services/notification.service'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'
import { CoreSettingsService } from '../../../settings/core-settings.service'

@Component({
  selector: 'bmcore-select-license-popup',
  templateUrl: './bmcore-select-license-popup.component.html',
  styleUrls: ['./bmcore-select-license-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSelectLicensePopupComponent implements OnInit {
  @Input() colorSettingsMode = false

  lg: LgType
  currencySign: CurrencySignType
  showLicensePopup = false
  trackLicenses: Array<ILicense> = []
  activeLicenseId: string
  activeTrack: ITrack
  url = ''
  isLoader = false

  public BaseAssetsURL: string

  bmstvUrl: string

  constructor(
    private coreSettingsService: CoreSettingsService,
    private cartService: CartService,
    private licenseService: LicenseService,
    private tracksService: TracksService,
    private router: Router,
    private i18nService: I18nService,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.BaseAssetsURL = coreSettingsService.settings.urls.assetsURL
    this.bmstvUrl = this.coreEnvironmentService.getBmstvURL()
  }

  ngOnInit() {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
    this.getUrl()
    this.cartService.addSubscriber('want-add-beat', this.onWantBeat.bind(this))
  }

  getUrl() {
    this.url = this.router.url
  }

  onWantBeat({ beatId, licenseId }: { beatId: number; licenseId?: string }) {
    this.isLoader = true
    this.getUrl()
    this.showLicensePopup = true

    /* forkJoin works like Promise.all*/
    /* https://www.learnrxjs.io/learn-rxjs/operators/combination/forkjoin*/
    forkJoin([this.licenseService.getLicensesByBeat(beatId), this.tracksService.getBeatById(beatId)]).subscribe(
      ([res1, res2]) => {
        /* getLicensesByBeat */
        this.trackLicenses = res1.items
        if (this.trackLicenses.length) {
          this.activeLicenseId = licenseId ? licenseId : res1.items[0].id
        }
        /* getBeatById */
        this.activeTrack = res2

        // Если beatmaker был зареган на западной версии, но находиться в каталоге русской версии,
        // то редиректить на страницу с битом beatmakers.tv
        // https://beatmakers.tv/beat/148
        if (this.activeTrack.engMode) {
          document.location.href = `${this.bmstvUrl}/beat/${this.activeTrack.id}`
          return
        }

        this.isLoader = false
      }
    )
  }

  closeLicensePopup() {
    /* No parent scroll on modal scroll */
    /* https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened */
    /* https://stackoverflow.com/questions/43542373/angular2-add-class-to-body-tag */
    this.renderer.removeClass(document.body, 'modal-open')

    this.showLicensePopup = false
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeLicensePopup()
    }
  }

  setFeatures(licenseId: string) {
    this.activeLicenseId = licenseId
  }

  wantToAddBeat($event: MouseEvent, beatId: number, licenseId: string) {
    this.cartService.addBeat(beatId, licenseId)
    this.showLicensePopup = false
    this.showNotification()
  }

  showNotification() {
    this.notificationService.handleInfo(this.lg.cartPage.beatAddedToCart)
  }
}
